import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { plazaServices } from "../tollPlaza/plazaReportService";
import { Dropdown } from "primereact/dropdown";
import SingleUpload from "../../components/SingleUpload";
import MultiUpload from "../../components/MultiUpload";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";

const DesignerImage3DModel = () => {
    const [vendorList, setVendorList] = useState([]);
    const [vendor, setVendor] = useState();
    const [uploadType, setUploadType] = useState("images");
    const [uploadCount, setUploadCount] = useState(null);
    const [tempUploadCount, setTempUploadCount] = useState(null);
    const [skuListLoading, setSKUListLoading] = useState(false);
    const [skus, setSKUList] = useState(null);
    const [sku, setSKU] = useState("");
    const toast = useRef();
    const serviceId = localStorage.getItem("serviceId");
    const { usersVendors } = useSelector((state) => state.usersVendors);
    useEffect(() => {
        fetchVendorsList();
    }, []);
    useEffect(() => {
        resetAll();
    }, [uploadType]);

    const resetAll = () => {
        setTempUploadCount(null);
        setUploadCount(null);
        setVendor(null);
        setSKUValue(null);
        setSKUListLoading(false);
        setSKUList(null);
    };
    const fetchVendorsList = async () => {
        try {
            const vendorResponse = await plazaServices.general(serviceId, {}, "nq-products-vendors");
            let vendorsList;
            if (usersVendors && usersVendors.length) {
                vendorsList = vendorResponse.filter((v) => usersVendors.includes(v.vendorID));
            } else {
                vendorsList = vendorResponse;
            }
            const formattedVendors = vendorsList.map((v) => ({ label: v.name, value: v.name }));
            setVendorList(formattedVendors);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
        }
    };
    const fetchVendorsSKUList = async (uploadCount, ven) => {
        setSKUListLoading(true);
        setSKUValue(null);
        setSKUList(null);

        try {
            let query = {
                filter: { vendor: ven ?? vendor },
            };
            let products = await plazaServices.general(serviceId, query, "nq-product-catelogue");
            const formattedSKUs = products.map((p) => ({ label: p.sku, value: p.sku }));
            setSKUList(formattedSKUs);
            setUploadCount(uploadCount);
            setTempUploadCount(null);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setSKUListLoading(true);
        }
    };

    const updateUploadCount = async (uploadCount) => {
        setTempUploadCount(uploadCount);
        await fetchVendorsSKUList(uploadCount);
    };
    const setSKUValue = (value) => {
        setSKU(value);
    };

    const changeUpdateType = (value) => {
        setUploadType(value);
    };
    const showToast = (severity, summary, detail) => {
        toast?.current?.show({ severity: severity, summary: summary, detail: detail });
    };

    return (
        <div className="col-12 ">
            <Toast ref={toast} />
            <h2 className="font-larken m-0 charcoal-color mb-3" style={{ whiteSpace: "nowrap", fontFamily: "Inter" }}>3D Model / Image Upload</h2>

            <div className="designer-card-border p-4 ">
                <p className="text-center mb-3 text-lg font-Gerstner-ProgramRegular" style={{ letterSpacing: "2px" }}>
                    SELECT TYPE OF UPLOAD
                </p>
                {/* Upload type selection */}
                <div className="grid justify-content-center align-items-center mb-5 text-center">
                    {/* 3D Model Upload */}
                    <div className="col-12 sm:col-12 md:col-4 lg:col-3 flex flex-column align-items-center">
                        <div
                            onClick={() => changeUpdateType("3D_model")}
                            className="cursor-pointer flex flex-column align-items-center transition-all"
                            style={{
                                backgroundColor: "#E5E1CF",
                                borderRadius: "16px",
                                border: uploadType === "3D_model" ? "2px solid #9AAB89" : "1px solid transparent",
                                padding: "10px",
                            }}
                        >
                            <img src="/images/sofa1.png" alt="3D Model Upload" className="w-8rem h-auto mb-3" />
                        </div>
                        <span className="font-Gerstner-ProgramRegular mt-2">3D Model Upload</span>
                    </div>

                    {/* OR in its own col */}
                    <div className="col-12 sm:col-12 md:col-1 flex justify-content-center align-items-center md:mb-0">
                        <span className="font-Gerstner-ProgramRegular">OR</span>
                    </div>

                    {/* Image Upload */}
                    <div className="col-12 sm:col-12 md:col-4 lg:col-3 flex flex-column align-items-center">
                        <div
                            onClick={() => changeUpdateType("images")}
                            className="cursor-pointer flex flex-column align-items-center transition-all"
                            style={{
                                backgroundColor: "#E5E1CF",
                                borderRadius: "16px",
                                border: uploadType === "images" ? "2px solid #9AAB89" : "1px solid transparent",
                                padding: "10px",
                            }}
                        >
                            <img src="/images/sofa2.png" alt="Image Upload" className="w-8rem h-auto mb-3" />
                        </div>
                        <span className="font-Gerstner-ProgramRegular mt-2">Image Upload</span>
                    </div>
                </div>
                {/* Vendor selection */}
                <div className="grid justify-content-center">
                    <div className="col-6">
                        <label className="mb-2 font-Gerstner-ProgramRegular text-left block">Vendor</label>
                        <Dropdown
                            disabled={!uploadType}
                            value={vendor}
                            options={vendorList}
                            onChange={async (e) => {
                                setVendor(e.value);
                                if (vendor && vendor !== e.value) {
                                    await fetchVendorsSKUList(uploadCount, e.value);
                                }
                            }}
                            placeholder="Select Vendor"
                            filter
                            filterPlaceholder="Search Vendor"
                            className="font-Gerstner-ProgramRegular w-full"
                            style={{
                                borderRadius: "20px",
                                border: "1px solid #9AAB89",
                                height: "3rem",
                            }}
                        />
                    </div>
                </div>
                {/* Upload buttons */}
                {!uploadCount && (
                    <div className="p-0 col-12 flex justify-content-center flex-wrap align-items-center mt-6" style={{ gap: 10 }}>
                        <Button
                            disabled={!vendor || !uploadType || skuListLoading}
                            label={skuListLoading && tempUploadCount === "single" ? "PLEASE WAIT" : "SINGLE UPLOAD"}
                            icon=""
                            className="p-button-rounded p-button-info font-Gerstner-ProgramRegular px-4 charcoal-color flex items-center justify-center gap-2"
                            style={{ letterSpacing: "1.44px", backgroundColor: "#9AAB89" }}
                            onClick={() => updateUploadCount("single")}
                        ></Button>
                        <div className="col-12 sm:col-12 md:col-1 flex justify-content-center align-items-center">
                            <span className="font-Gerstner-ProgramRegular">OR</span>
                        </div>

                        <Button
                            disabled={!vendor || !uploadType || skuListLoading}
                            label={skuListLoading && tempUploadCount === "bulk" ? "PLEASE WAIT" : "BULK UPLOAD"}
                            icon=""
                            className="p-button-rounded p-button-info font-Gerstner-ProgramRegular  px-4 charcoal-color"
                            style={{ letterSpacing: "1.44px", backgroundColor: "#9AAB89" }}
                            onClick={() => updateUploadCount("bulk")}
                        />
                    </div>
                )}

                {uploadCount && uploadCount === "single" && <SingleUpload serviceId={serviceId} vendor={vendor} uploadType={uploadType} skus={skus} sku={sku} setSKUValue={setSKUValue} showToast={showToast}></SingleUpload>}
                {uploadCount && uploadCount === "bulk" && <MultiUpload serviceId={serviceId} vendor={vendor} uploadType={uploadType} skus={skus} sku={sku} setSKUValue={setSKUValue} showToast={showToast}></MultiUpload>}
            </div>
            {uploadCount && uploadCount === "bulk" && (
                <>
                    <h3 className="font-larken mt-3 mb-0">Instructions:</h3>
                    <div className="ml-3 text-lg font-Gerstner-ProgramRegular">
                        <span>1. </span>
                        <span className="">
                            {uploadType === "images"
                                ? "Name each file with the product's SKU followed by an underscore(_). Example: 12345_front.jpg, 12345_side.png, 12345_back.jpg"
                                : "Name each file with the product's SKU. Example: 12345.glb, 12345.dwg"}
                        </span>
                        <p className="m-0 my-2 ml-4 font-larken">OR</p>
                        <span>2. </span>
                        <span className="text-lg font-Gerstner-ProgramRegular">
                            {uploadType === "images"
                                ? "Combine all images for a single product into a ZIP file. The ZIP file itself must be named using only the product's SKU. Example: 12345.zip"
                                : "Combine all product files into a ZIP file. Each file inside the ZIP must be named using only the product's SKU. Example: 12345.glb, 12345.dwg"}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

export default DesignerImage3DModel;
